import { Link } from "react-router-dom";

import { Checkbox } from "@/components/ui/checkbox";
import { PRIVACY_PATH, TERMS_PATH } from "@/components/legal/legal-footer";

/**
 * The consent checkboxes registration requires. The server is what decides —
 * `registerWithEmail` refuses without `acceptsTerms` / `acceptsChildData`, and
 * the Google button only creates an account when it carries `terms=1` and
 * `child_data=1` — so these are the half that lets somebody tick them.
 *
 * Two boxes, never one (issue #56, GDPR art. 7–8): consent to process a
 * child's data may not be bundled with agreeing to the terms, so each is its
 * own unticked box with its own link.
 *
 * The links open in a new tab: following one mid-registration and coming back
 * with the browser's back button would empty the form.
 */
export function TermsConsent({
  checked,
  onChange,
  id = "terms-consent",
}: {
  checked: boolean;
  onChange: (value: boolean) => void;
  id?: string;
}) {
  return (
    <ConsentRow id={id} checked={checked} onChange={onChange}>
      Sutinku su{" "}
      <Link to={TERMS_PATH} target="_blank" className="underline underline-offset-4">
        naudojimosi taisyklėmis
      </Link>
      .
    </ConsentRow>
  );
}

export function ChildDataConsent({
  checked,
  onChange,
  id = "child-data-consent",
}: {
  checked: boolean;
  onChange: (value: boolean) => void;
  id?: string;
}) {
  return (
    <ConsentRow id={id} checked={checked} onChange={onChange}>
      Sutinku, kad mano vaiko duomenys būtų tvarkomi pagal{" "}
      <Link to={PRIVACY_PATH} target="_blank" className="underline underline-offset-4">
        privatumo politiką
      </Link>
      .
    </ConsentRow>
  );
}

export function ConsentRow({
  id,
  checked,
  onChange,
  children,
}: {
  id: string;
  checked: boolean;
  onChange: (value: boolean) => void;
  children: React.ReactNode;
}) {
  return (
    <div className="flex items-start gap-2.5">
      <Checkbox
        id={id}
        checked={checked}
        onCheckedChange={(value) => onChange(value === true)}
        className="mt-0.5"
      />
      <label htmlFor={id} className="text-sm leading-snug">
        {children}
      </label>
    </div>
  );
}
